import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[headerTemplate]',
})
export class HeaderTemplateDirective {
  @Input()
  field!: string;
  constructor(public template: TemplateRef<any>) {}
}
